var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-switch',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.handleChange},model:{value:(_vm.checkStatus),callback:function ($$v) {_vm.checkStatus=$$v},expression:"checkStatus"}})}
var staticRenderFns = []

export { render, staticRenderFns }